<template>
  <section>
    <div class="row col-12 q-gutter-sm items-center q-mt-md">
      <div class="col-2">
        <ListaUnidadesSelect />
      </div>
      <div class="col-3">
        <q-file label="Selecione o Template" outlined dense v-model="file">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <div class="col-2">
        <q-btn
          color="positive"
          no-caps
          icon="file_upload"
          label="Enviar Template"
          @click="enviarTemplate"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  props: {
    mapeamento: {
      type: String,
    },
    link: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  setup(props) {
    const quasar = useQuasar();
    const store = useStore();
    const file = ref("");

    // Função para enviar planilha para n8n
    const enviarParaN8n = async (planilhaBase64, mapeamento) => {
      const n8nEndpoint =
        "https://n8n.devops.multpex.com.br/webhook/356d6cf5-5d36-4a04-8759-0eb4b8f150c6";

      const payload = {
        planilha: planilhaBase64,
        mapeamento: mapeamento,
        unidade: store.state.org.unidadeData.nome,
        tenant: store.state.autenticacao.cliente[0],
        timestamp: new Date().toISOString(),
        origem: "catalogo-upload",
      };

      const response = await fetch(n8nEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(
          `Erro HTTP: ${response.status} - ${response.statusText}`
        );
      }

      return await response.json();
    };

    const enviarTemplate = async () => {
      if (file.value == "" || file.value.name.indexOf("xlsx") == -1) {
        quasar.notify({
          message: "O tipo do arquivo não é aceito, ou o campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            const response = await store.dispatch("catalogo/uploads", {
              planilha: reader.result,
              mapeamento: props.mapeamento,
              unidade: store.state.org.unidadeData.id,
            });

            quasar.notify({
              message:
                response.data?.result ||
                response.data?.message ||
                "Template enviado com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });

            // Enviar para n8n apenas em caso de sucesso
            try {
              await enviarParaN8n(reader.result, props.mapeamento);
              console.log("Planilha enviada para n8n com sucesso");
            } catch (n8nError) {
              console.error("Erro ao enviar para n8n:", n8nError);
              // Não quebrar o fluxo principal se n8n falhar
              quasar.notify({
                message:
                  "Template enviado, mas falha no processamento secundário",
                color: "warning",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          } catch (error) {
            const errorMessage =
              error.response?.data?.result?.error ||
              error.response?.data?.error ||
              error.response?.data?.message ||
              error.response?.data?.result ||
              "Erro ao enviar template";

            quasar.notify({
              message: errorMessage,
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        };
        file.value = "";
      } catch (error) {
        console.log(error);
        file.value = "";
      }
    };
    return {
      enviarTemplate,
      enviarParaN8n,
      file,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
